export default "__VITE_ASSET__Cs6csyDS__"